import { Injectable } from '@angular/core';
import { Message } from '../models/common/message.model';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  public types: {
    'error': 'danger',
    'success': 'success',
    'warning': 'warning'
  }

  public constructor() {
    this.types = {
      error: 'danger',
      success: 'success',
      warning: 'warning'
    };
  }

  public timeout = 10000;

  public messages: Array<Message> = [];

  public addMessage(message: Message, useTimeout?: boolean, timeout?: number) {
    this.messages.push(message);

    if (useTimeout || useTimeout == undefined) {
      setTimeout(() => {
        this.messages.splice(this.messages.indexOf(message), 1);
      }, timeout ? timeout : this.timeout);
    }
  }
}
